import React from 'react';

const ContentDescription = ({children}) => {
  return <p className="content__description">{children}</p>;
};

export default ContentDescription;
